import { api } from "@/lib/api";
import {
  Payment,
  PaymentDtoSchema,
  paymentFromDto,
  paymentToDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getPaymentQueryOptions, getPaymentsQueryOptions } from "./get.hooks";

export function useUpdatePayment(
  reservationId: string,
  opts?: {
    onSuccess?: (payment: Payment) => void;
    onError?: () => void;
  },
) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (payment: Payment) => {
      const dto = paymentToDto(payment);
      const result = await api.put("/api/payments", dto, PaymentDtoSchema);
      return paymentFromDto(result);
    },
    onSuccess: (payment) => {
      queryClient.setQueryData(
        getPaymentsQueryOptions(reservationId).queryKey,
        (old) => old?.map((d) => (d.id === payment.id ? payment : d)),
      );
      queryClient.setQueryData(
        getPaymentQueryOptions(payment.id ?? "").queryKey,
        () => payment,
      );
      toast({
        title: "toast.paymentUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(payment);
    },
    onError: () => {
      toast({
        title: "toast.updatePaymentError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
